import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { DepositFormDataService } from '../../deposit-form-data.service';
import { Subject, takeUntil } from 'rxjs';
import { AutoPopulateKeys } from '../../../shared/configurations/auto-populate-keys.config';
import { CustomTranslatePipe } from '../../../shared/pipes/custom-translate.pipe';
import { DepositFreeTextComponent } from '../deposit-free-text/deposit-free-text.component';

@Component({
    selector: 'esp-deposit-coverage',
    templateUrl: './deposit-coverage.component.html',
    styleUrls: ['./deposit-coverage.component.scss'],
    imports: [DepositFreeTextComponent, CustomTranslatePipe]
})
export class DepositCoverageComponent implements OnInit, OnDestroy {
  depositFormDataService = inject(DepositFormDataService);

  private coverageDestroy = new Subject<void>();

  ngOnInit() {
    this.onChanges();
  }

  onChanges(): void {
    this.depositFormDataService.coverage.valueChanges
      .pipe(takeUntil(this.coverageDestroy))
      .subscribe((value) => {
        if (!this.depositFormDataService.startPopulating) {
          this.depositFormDataService.removeKeyFromAutoPopulatedArray(
            AutoPopulateKeys.COVERAGE
          );
        }
      });
  }

  get isAutoPopulated() {
    return this.depositFormDataService.isKeyAutoPopulated(
      AutoPopulateKeys.COVERAGE
    );
  }

  ngOnDestroy() {
    if (!this.coverageDestroy.isStopped) {
      this.coverageDestroy.next();
      //unsubscribe from the subject itself
      this.coverageDestroy.unsubscribe();
    }
  }
}
